import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import type { EmployeeSchedules } from '@/schemas/API/GET/employee/schedule/response';

export default function useEmployeeSchedule() {
  const { employeeId } = useParams<{ employeeId: string }>();

  const {
    data: employeeSchedule,
    error,
    mutate,
  } = useSWR<EmployeeSchedules>(
    employeeId ? `/employees/${employeeId}/schedule` : null,
    getFetcher
  );

  return {
    employeeSchedule,
    error,
    mutate,
  };
}
